import { all, fork } from 'redux-saga/effects';
import captchaReducer from './captcha/reducer';
import captchaSaga from './captcha/saga';
import checkReduces from './check/reducer';
import checkSaga from './check/saga';

import loginReducer from './login/reducer';
import loginSaga from './login/saga';
import logoutReducer from './logout/reducer';
import logoutSaga from './logout/saga';
import runAsReducer from './runAs/reducer';
import runAsSaga from './runAs/saga';

export const authorizationReducers = {
  login: loginReducer,
  logout: logoutReducer,
  check: checkReduces,
  captcha: captchaReducer,
  runAs: runAsReducer,
};

export function* authorizationSagas() {
  yield all(
    [loginSaga, logoutSaga, checkSaga, captchaSaga, runAsSaga].map(function (saga) {
      return fork(saga);
    }),
  );
}
